import React from 'react'
import classnames from 'classnames'

import { PreviousDayOrderMatrix, TimeSlot, MinimalItem } from '../../../core/pre-making'
import tableStyles from '../../styles/modules/table.module.scss'
import styles from '../../styles/modules/pre-making-detail/pre-making-detail-table.module.scss'

interface Props {
  previousDayOrderMatrix?: PreviousDayOrderMatrix
  timeSlots: TimeSlot[]
  uniqueItems: MinimalItem[]
}

const PreviousDayOrderCountsSection: React.FC<Props> = ({
  previousDayOrderMatrix,
  timeSlots,
  uniqueItems,
}) => {
  // 前日提供数データがない場合は表示しない
  if (!previousDayOrderMatrix || uniqueItems.length === 0) {
    return null
  }

  // 行の合計を計算
  const calculateRowTotal = (timeSlot: TimeSlot) => {
    return uniqueItems.reduce((total, item) => {
      const quantity = previousDayOrderMatrix[timeSlot.id.toString()]?.[item.id.toString()]?.orderCount || 0
      return total + quantity
    }, 0)
  }

  return (
    <>
      <h3 className={tableStyles.title} style={{ marginTop: '3.2rem' }}>
        前日提供杯数
      </h3>

      <div
        className={classnames(
          tableStyles.wrapper,
          tableStyles.zebra,
          styles.preMakingTableWrapper
        )}
        style={{ marginTop: '2.4rem' }}
      >
        <table className={tableStyles.container}>
          <thead>
            <tr className={tableStyles.row}>
              <th className={tableStyles.cell} style={{ width: '80px' }}>
                時間枠
              </th>
              <th className={tableStyles.cell} style={{ width: '24px' }}>
                合計
              </th>
              {uniqueItems.map(item => (
                <th key={`prev-header-${item.id}`} className={tableStyles.cell}>
                  {item.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {timeSlots
              .filter(timeSlot => {
                const hour = parseInt(timeSlot.from.split(':')[0], 10)
                return hour >= 6 && hour < 23
              })
              .sort((a, b) => a.id - b.id)
              .map(timeSlot => {
                const rowTotal = calculateRowTotal(timeSlot)

                return (
                  <tr key={`prev-${timeSlot.id}`} className={tableStyles.row}>
                    <td className={tableStyles.cell}>
                      {timeSlot.from}~{timeSlot.to}
                    </td>
                    <td className={tableStyles.cell}>
                      {rowTotal}
                    </td>
                    {uniqueItems.map(item => {
                      const orderCount =
                        previousDayOrderMatrix[timeSlot.id.toString()]?.[
                          item.id.toString()
                        ]?.orderCount || 0

                      return (
                        <td
                          key={`prev-cell-${timeSlot.id}-${item.id}`}
                          className={tableStyles.cell}
                        >
                          {orderCount}
                        </td>
                      )
                    })}
                  </tr>
                )
              })}
            
          </tbody>
        </table>
      </div>
    </>
  )
}

export default PreviousDayOrderCountsSection